function user(state = {

  isAuthenticated: false,
  isAuthenticating: false,
  isAuthenticatingError: false,
  authenticatingErrorMessage: '',
  billingInfo: null,
  access_token: null,
  email: null,
  uid: null,
  admin: false,

}, action) {
  switch (action.type) {
    case 'USER_LOGIN_REQUESTED': {
      return {
        ...state,
        isAuthenticating: true,
        email: action.email,
      };
    }

    case 'LOGIN_SUCCESS': {
      return {
        ...state,
        isAuthenticating: false,
        isAuthenticated: true,
        isAuthenticatingError: false,
        authenticatingErrorMessage: '',
        access_token: action.token.access_token,
        admin: Boolean(Number(action.credentials.data.superuser)),
      };
    }

    case 'LOGIN_FAILED': {
      return {
        ...state,
        isAuthenticating: false,
        isAuthenticatingError: true,
        authenticatingErrorMessage: action.message,
      };
    }

    case 'RESTORE_USER_BY_TOKEN_SUCCESS': {
      return {
        ...state,
        isAuthenticating: false,
        isAuthenticated: true,
        access_token: localStorage.getItem('token'),
        email: action.credentials.email,
        admin: Boolean(Number(action.credentials.superuser)),
      };
    }

    case 'FETCH_BILLING_INFO_SUCCESS': {
      const {
        szaml_titulus, szaml_vezeteknev, szaml_keresztnev,
        szaml_nev,
        szaml_cim, szaml_irsz, szaml_telepules, szaml_adoszam,
      } = action.data;

      return {
        ...state,
        billingInfo: {
          szaml_nev,
          szaml_titulus,
          szaml_vezeteknev,
          szaml_keresztnev,
          szaml_cim,
          szaml_irsz,
          szaml_telepules,
          szaml_adoszam,
        },
      };
    }

    case 'LOGOUT_SUCCESS': {
      return {
        ...state,
        isAuthenticated: false,
        access_token: null,
        username: undefined,
        uid: undefined,
      };
    }

    default:
      return state;
  }
}


export default user;



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/reducers/user.js